import { formatNumber, isUnsafeInteger } from "@validereinc/utilities";
import classNames from "classnames/bind";
import { isNaN } from "es-toolkit/compat";
import React from "react";
import { Icon } from "../../Icon";
import { colours } from "../../constants/colours";
import { DataDisplayWithAdornment } from "../_components/DataDisplayWithAdornment";
import styles from "./IntegerDataDisplay.module.scss";
import type { IntegerDataDisplayProps } from "./types";

const cx = classNames.bind(styles);

const IntegerDataDisplay = ({
  value,
  alignment = "right",
  formattingOpts,
  parsingOpts,
  unit,
  emptyText = "-",
  showInvalidIndicator = true,
  invalidText = "Unsupported data type",
  className,
  style,
  isInline = false,
  isBusy = false,
  isLoading = false,
  as = "p",
}: IntegerDataDisplayProps) => {
  const isUnsafe = isUnsafeInteger(value);
  const trueValue =
    parsingOpts?.shouldBeSafe && isUnsafe === true
      ? formatNumber(
          value,
          {
            ...(formattingOpts ?? {}),
            overrideOpts: { notation: "scientific" },
          },
          parsingOpts
        )
      : formatNumber(value, formattingOpts, parsingOpts);
  const isEmpty = value === null || value === "" || value === undefined;
  const isInvalid = trueValue === null || isNaN(value);

  return (
    <DataDisplayWithAdornment
      showAdornment={showInvalidIndicator && !isEmpty && isInvalid}
      alignment={alignment}
      isInline={isInline}
      isBusy={isBusy}
      isLoading={isLoading}
      adornmentSlot={({ iconProps, className }) => (
        <span className={className}>
          <Icon
            {...iconProps}
            variant="warning"
            colour={colours.status.warning}
            alt={invalidText}
            aria-roledescription="Warning Icon"
          />
        </span>
      )}
      className={cx("container", className, isInvalid && "bare")}
      style={style}
      as={as}
    >
      {isEmpty || isInvalid ? (
        emptyText
      ) : (
        <>
          {trueValue}
          {unit ? (
            <span
              className={cx("unit")}
              data-is-unit-display
            >
              {unit}
            </span>
          ) : null}
        </>
      )}
    </DataDisplayWithAdornment>
  );
};

export default IntegerDataDisplay;
